import { render, staticRenderFns } from "./push-money-query-detail.vue?vue&type=template&id=5e03c244&scoped=true&"
import script from "./push-money-query-detail.vue?vue&type=script&lang=ts&"
export * from "./push-money-query-detail.vue?vue&type=script&lang=ts&"
import style0 from "./push-money-query-detail.vue?vue&type=style&index=0&id=5e03c244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e03c244",
  null
  
)

export default component.exports